import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

import { Covid19Closure } from 'OpsCenter/ops-support/covid-19/closure/covid-19-closure';
import { Covid19ClosureService } from 'OpsCenter/ops-support/covid-19/closure/covid-19-closure.service';
import { OC_API } from 'OpsCenter/app.constants';

@Component({
  selector: 'app-covid-19-closure',
  template: require('./covid-19-closure.component.html'),
  styles: [require('./covid-19-closure.component.less')],
})
export class Covid19ClosureComponent implements OnInit, OnDestroy {
  @ViewChild('form', {static: false}) form: NgForm;
  public startDate;
  public startTime;
  public endDate;
  public dailyStartOfBusinessDay = true;
  public dailyEndOfBusinessDay = true;
  public dailyStartTime = '';
  public dailyEndTime = '';
  public closeCountry = false;
  public merchantIds;
  public countries;
  public country;
  public cancelReservations = true;
  public startAfterEnd = false;

  private destroy$ = new Subject();

  constructor(private merchantClosureService: Covid19ClosureService, private notificationService: ToastrService) {
  }

  ngOnInit() {
    this.getCountries();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public onDateChange(): void {
    this.startAfterEnd = false;
  }

  public save(): void {
    this.markAsDirty();

    const dates = this.getDates(this.form.value);

    if (!this.areDatesValid(dates)) {
      this.notificationService.error('Start date can not be after end date');
      return;
    }

    const closure = this.mapToMerchantClosure(this.form.value, dates);

    this.merchantClosureService.save(closure).subscribe(
      () => {
        this.notificationService.success('You will be notified via email once the operation will complete');
      },
      () => this.notificationService.error('Please try again'),
    );
  }

  private mapToMerchantClosure(form, dates): Covid19Closure {
    const {
      startTime,
      dailyEndOfBusinessDay,
      dailyStartOfBusinessDay,
      dailyStartTime,
      dailyEndTime,
      closeCountry,
      country,
      cancelReservations,
      merchantIds,
    } = form;
    const [hours, minutes] = startTime.split(':');
    const start = dates.start.hours(hours).minutes(minutes).seconds(0).format(OC_API.DATE_FORMAT_NO_TIMEZONE);
    const end = dates.end.format(OC_API.JUST_DATE_FORMAT);

    const merchantsIdentifier = closeCountry ? country : `${merchantIds},`; // need to add comma if one merchant so API knows it is not the country

    return {
      merchantsIdentifier,
      start,
      end,
      dailyStartOfBusinessDay,
      dailyEndOfBusinessDay,
      dailyStartTime,
      dailyEndTime,
      cancelReservations,
    };
  }

  private getDates(values): any {
    const { startDate, endDate } = values;

    const start = moment(startDate, 'DD.MM.YYYY');
    const end = moment(endDate, 'DD.MM.YYYY');

    return { start, end };
  }

  private areDatesValid(dates): boolean {
    const { start, end } = dates;

    if (!(start.isValid() && end.isValid())) {
      return false;
    }

    if (start.isAfter(end, 'd')) {
      this.startAfterEnd = true;
      return false;
    }

    return true;
  }

  private markAsDirty(): void {
    const formGroupControls = this.form.controls;
    Object.keys(formGroupControls).forEach(control => formGroupControls[control].markAsDirty());
  }

  private getCountries(): void {
    this.merchantClosureService.getAllCountries().pipe(takeUntil(this.destroy$)).subscribe(countries => {
      this.countries = countries;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/ops-support/covid-19/closure/covid-19-closure.component.ts